<template>
 
  <div id="Vue"  >
 
  <el-row >
  <el-col :span="22" :offset="1"> 
   
  <el-row  style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick" >
    <el-tab-pane label="单个验证" name="first">
	
	  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
 
	  <el-form-item label="邮箱名称">
		<el-input v-model="form.email" placeholder="请输入需要验证的邮箱" @keyup.enter.native="onSubmit"  style="width:260px"   ></el-input>
	  </el-form-item>
	  
	  <el-form-item>
		<el-button type="primary" :loading="loading" @click="onSubmit" >验证</el-button>
	  </el-form-item>
	  </el-form>
	
	
	</el-tab-pane>
    <!--el-tab-pane label="按姓名搜索" name="second"> 
	  <el-form ref="form"  :inline="true" :model="form" label-width="80px" class="demo-form-inline">
 
	  <el-form-item label="英文全名">
		<el-input v-model="form.name" placeholder="请输入英文姓名"  style="width:260px"  ></el-input>
	  </el-form-item>
	  <el-form-item label="邮箱后缀">
		<el-input v-model="form.mailpost" placeholder="请输入邮箱后缀, 例如 facebook.com" style="width:260px"   ></el-input>
	  </el-form-item>	  
	  <el-form-item>
		<el-button type="primary" :loading="loading" @click="onLookup" >搜索</el-button>
	  </el-form-item>
	  </el-form>
	</el-tab-pane-->
     
  </el-tabs>
    
 
  </el-row>
 
  <el-row style=" padding:20px;margin-top:10px;background: #fff;  " justify="left"  >
 
   <el-empty v-if="check_state == 0"  description=""></el-empty>
   <el-skeleton v-if="loading == true"  :rows="6" animated />
   <el-result v-if="check_state == 1 && check_code==1 && loading==false"  icon="success" :subTitle="email" title="有效">
 
    </el-result>
   <el-result v-if="check_state == 1 && check_code<=0 && loading==false"  icon="error" :subTitle="email" :title="check_info">
 
    </el-result>
  </el-row>  
  </el-col>
  </el-row>
</div>
</template>
<style>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }
</style>

<script>
  
export default {
 
        data () {
            return {
			activeName: 'first',
	    	componentName: 'info',
		    userInfo: {},
			user_id: 0,
			loading: false,
			login_state : false,
			check_code: 100,
			check_state: 0,
			check_info: '',
			email: '',
			status:true,
 
			form:{ name:'', 
			       email:'',
				   mailpost: '', 
				    
				   
				 }, 
			}  
        },
        methods: {
 	        onLookup(){
		 	  if (this.form.email == ''){
				    this.$message({
							message: '待验证的邮箱不能为空 ! ',
							type: 'warning'
							});
				    return;
				}	 		    
			    this.email = this.form.email;
				this.getInfo();
				},
		    onSubmit(){
		 	  if (this.form.email == ''){
				    this.$message({
							message: '待验证的邮箱不能为空 ! ',
							type: 'warning'
							});
				    return;
				}
                this.check_state = 1;	 		    
			    this.email = this.form.email;
				this.getInfo();
				},
			handleClick(tab, event){
			    this.check_state = 0;
			},
			getInfo(){
				let that = this;  
					 				 
				that.loading = true; 
				  $.ajax({
					  type: "GET",
					  data:  {user_id: that.user_id,   
							  email:that.form.email, 
							  },
					  url: "https://www.myferp.com/admin/email/emailCheck",
					  dataType: "json",  //返回类型为 json
					  beforeSend: function (request) {
						request.setRequestHeader("X-Nideshop-Token", localStorage.getItem('token') );
						},   
					  error: function(XMLHttpRequest, textStatus, errorThrown) { 
						  that.loading = false;
						  that.$message({
							message: data,
							type: 'error'
							});
								return false;
							},             
					  success: function (data) {
						
						  console.log(JSON.stringify(data)); 
						  that.form.email = '';
						  that.check_code = data.data.info.code;
						  if (data.data.info.code == 1){
						      that.check_info = '有效';
						     }
						  if (data.data.info.code == 0){
						      that.check_info = '邮箱不存在('+ data.data.info.msg + ')';
						     }
						  if (data.data.info.code == -1){
						      that.check_info = '格式错误	';
						     }
						  if (data.data.info.code == -2){
						      that.check_info = '链接失败请重试	';
						     }					 
						  if (data.data.info.code == -5){
						      that.check_info = '未验证出来('+ data.data.info.msg + ')';
						     }								  
						  that.loading = false;					  
						  }
					  });
		    },
			
			login()
			{
			  this.$router.push({
					path: '/login',
					params: {
					  sometext: ''
					}
				  }); 
			},

			back()
			{ 
			  this.$router.push({
					path: '/home/index',
					params: {
					  sometext: ''
					}
				  });  
			},
 

		},
        mounted() {   
				let userInfo = localStorage.getItem('userInfo'); //判断登录状态
				console.log( 'user:' + typeof userInfo);    
				let info = {}; 
				if (userInfo != null && userInfo != '' && typeof userInfo != undefined){
				    info = JSON.parse(userInfo);
				    this.user_id = info.id;  
					}
           },		   
		
    } ;

</script>
 


// WEBPACK FOOTER //
// src/components/customs/emailCheck.vue